module.exports = __webpack_public_path__ + "static/placeholder-350x150.png";